import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Alert from "react-s-alert";
import UsersService from "../utils/UsersService";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";
import AuthContext from "../auth-context";
import List from "./List";
import ManageTagsModal from "./ManageTagsModal";
import TaskFormModal from "./TaskFormModal";

class Index extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context;
    this.isAdmin = authStore.hasRole("admin");
    
    this.state = {
      users: [],
      stats: {
        total: 0,
        overdue: 0,
        due_today: 0,
        due_this_week: 0
      },
      showManageModal: false,
      showCreateModal: false,
      typesRefreshKey: 0
    };

    this.handleManageOptions = this.handleManageOptions.bind(this);
    this.handleCloseManageModal = this.handleCloseManageModal.bind(this);
    this.handleTypesUpdated = this.handleTypesUpdated.bind(this);
    this.handleCreateTask = this.handleCreateTask.bind(this);
    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);
    this.handleSaveTask = this.handleSaveTask.bind(this);
  }

  componentDidMount() {
    this.fetchUsers();
    this.fetchStats();
  }

  fetchUsers() {
    UsersService.allUsers().then(data => {
      this.setState({ users: data });
    });
  }

  fetchStats() {
    SalesPersonTasksService.stats().then(data => {
      this.setState({ stats: data });
    });
  }

  handleManageOptions() {
    this.setState({ showManageModal: true });
  }

  handleCloseManageModal() {
    this.setState({ showManageModal: false });
  }

  handleTypesUpdated() {
    // This will trigger a refresh in child components
    this.setState({ typesRefreshKey: this.state.typesRefreshKey + 1 });
    this.fetchStats();
  }

  handleCreateTask() {
    this.setState({ showCreateModal: true });
  }

  handleCloseCreateModal() {
    this.setState({ showCreateModal: false });
  }

  handleSaveTask(taskData) {
    SalesPersonTasksService.create(taskData)
      .then(() => {
        Alert.success("Task created successfully");
        this.handleCloseCreateModal();
        this.fetchStats();
        // Trigger refresh in List component
        this.setState({ typesRefreshKey: this.state.typesRefreshKey + 1 });
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors.join(", ")
          : "Failed to save task";
        Alert.error(errorMsg);
      });
  }

  render() {
    const { stats } = this.state;

    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 className="first-title">My Tasks</h3>
          
          <div>
            <Button
              bsStyle="success"
              onClick={this.handleCreateTask}
              style={{ marginRight: 10 }}
            >
              + Create Task
            </Button>
            
            {this.isAdmin && (
              <Button
                bsStyle="default"
                onClick={this.handleManageOptions}
              >
                <i className="fa fa-cog"></i> Manage Types
              </Button>
            )}
          </div>
        </div>

        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-sm-12">
            <div className="status-card-header">
              <span style={{ marginRight: 20 }}>Total: <strong>{stats.total}</strong></span>
              <span style={{ marginRight: 20, color: stats.overdue > 0 ? "red" : "inherit" }}>
                Overdue: <strong>{stats.overdue}</strong>
              </span>
              <span style={{ marginRight: 20 }}>Due Today: <strong>{stats.due_today}</strong></span>
              <span>Due This Week: <strong>{stats.due_this_week}</strong></span>
            </div>
          </div>
        </div>

        <List key={this.state.typesRefreshKey} users={this.state.users} />

        {this.state.showManageModal && (
          <ManageTagsModal
            onClose={this.handleCloseManageModal}
            onTypesUpdated={this.handleTypesUpdated}
          />
        )}

        {this.state.showCreateModal && (
          <TaskFormModal
            task={null}
            users={this.state.users}
            isAdmin={this.isAdmin}
            onClose={this.handleCloseCreateModal}
            onSave={this.handleSaveTask}
          />
        )}
      </div>
    );
  }
}

export default Index;
